import React, { useEffect } from "react";
import { getServiceProvider, setClaimRepairsEstimateFiles, setCurrentBlob, setCurrentBlobModal } from "globals/claims";
import { setLoading, setLoadingMessage } from "globals/overlays";
import { useDropzone } from "react-dropzone";
import { BiUpload } from "react-icons/bi";
import { FaExclamationTriangle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { getClaimsRepairsEstimateFiles } from "globals/claims";
import { toBase64 } from "../../helpers/policy/index.js";
import "./CustomFileUpload.scss";
import { toast } from "react-toastify";
import MarketValue from "./MarketValue/index.jsx";
import { FaEye } from "react-icons/fa";
import { IconContext } from "react-icons";
import { FaCheck } from "react-icons/fa";
import { FaExclamation } from "react-icons/fa";
import { useState } from "react";
import { object } from "yup";
import { truncate } from "helpers/globalFunctions";
import { useScreenType } from "globals/screenTypeHook.jsx";
import DocumentViewer from "components/DocumentViewer"
import DocumentCard from "./DocumentCard/DocumentCard.jsx";
import ClaimsNetworkLayer from "../../helpers/claim/index.js";

// Remove all image imports and replace with public path strings
// const upload_scd_active = require("assets/img/claims_icons/upload-scd-active.svg");
const upload_scd_active = "/assets/img/claims_icons/doc-upload.svg";
const upload_pe = "/assets/img/claims_icons/upload-pe.svg";
const delete_btn = "/assets/img/claims_icons/delete_icon.svg";
const uploadFolder = "/assets/img/document-upload-icons/upload_folder_icon.svg";
const uploadFileIcon = "/assets/img/document-upload-icons/file_upload_icon.svg";
const uploadFile = "/assets/img/document-upload-icons/upload_file_icon.svg";
const trashIcon = "/assets/img/document-upload-icons/trash_icon.svg";
const successIcon = "/assets/img/document-upload-icons/success_icon.svg";
const pdfUploadIcon = "/assets/img/document-upload-icons/pdf_upload_icon.svg";
const imageUploadIcon = "/assets/img/document-upload-icons/image_upload_icon.svg";
const expansionIcon = "/assets/img/document-upload-icons/expansion_icon.svg";
const viewIcon = "/assets/img/document-upload-icons/view_icon.svg";
const trashIcon2 = "/assets/img/document-upload-icons/trash_icon2.svg";
const dropdownIcon = "/assets/img/document-upload-icons/dropdown_icon.svg";
const fileUploadImg = "/assets/img/document-upload-icons/file_upload_img.svg";
import uploadIcon from "../../assets/img/cat_form/upload.svg";
export const MAX_SIZE = 20971520;

//Accepted file types for preview
export const ACCEPTED_PREVIEW_FILE_TYPES = ["pdf", "png", "jpeg", "jpg"];

/**
 *
 * @param {Object} props
 * @param {(e) => void} props.action
 * @param {Object[]} props.files
 * @param {(file, i) => void} props.remove
 * @param {String} props.placeHolder
 * @param {String=} props.description
 * @param {Boolean=}props.isSCDFlow
 * @param {Boolean=}props.isCatClaimForm
 * @param {Boolean=}props.isUploadCenter
 * @param {String=}props.sectionTitle
 * @param {Boolean=}props.isMarketValue
 * @param {Boolean=}props.isPolicyEditor
 * @param {Boolean=}props.isPolicyEditorContact
 * @param {String=} props.fileTypeName
 * @param {Number=} props.maxFiles
 * @param {Boolean=} props.disabled
 * @param {Boolean=} props.isMarketValueUpdate
 * @param {String=} props.title
 * @param {String=} props.mobileTitle
 * @param {React.ComponentType=} props.uploadTypeIcon
 * @param {String=} props.footerMessage
 * @param {Boolean=} props.smallUpload
 * @param {String} props.instruction
 * @param {String} props.errorHandling
 */

export default function CustomFileUpload({
	action,
	files,
	remove,
	placeHolder,
	description,
	fileTypeName,
	title = "",
	mobileTitle = "",
	isCatClaimForm = false,
	isSCDFlow = false,
	isUploadCenter = false,
	sectionTitle = "",
	isMarketValue = false,
	isPolicyEditor = false,
	isPolicyEditorContact = false,
	isMarketValueUpdate = false,
	maxFiles,
	disabled = false,
	isRequired = false,
	changeBorder = false,
	isWindscreenDamage = false,
	instruction = "", 
	uploadTypeIcon = undefined,
	footerMessage = "",
	smallUpload = false,
	errorHandling = undefined,
	hideFileList = false
}) {
	const serviceProvider = useSelector(getServiceProvider);
	const dispatch = useDispatch();
	let imgPositionIncrement = 0;
	const { name } = serviceProvider;
	const cachedFile = useSelector(getClaimsRepairsEstimateFiles);
	const [uploadDropdown, setUploadDropdown] = useState(false);
	const [documentViewSection, setDocumentViewSection] = useState(false);
	const [charLimit, setCharLimit] = useState(9);
	const { width, screenType, isMobile, isDesktop, isTablet, isLargeDesktop } = useScreenType();

	const [blobUrl, setBlobUrl] = useState();
	const [showDocument, setShowDocument] = useState(false);

	useEffect(() => {
		if (screenType === "mobile" || screenType === "small-mobile" || screenType === "medium-mobile") {
			setCharLimit(14);
		} else if (screenType === "medium-mobile" || screenType === "tablet") {
			setCharLimit(16);
		} else {
			setCharLimit(19);
		}
	}, [width]);

	const { getRootProps, getInputProps, open } = useDropzone({
		onDrop: async droppedFiles => {
			let fileUpload = await onDrop(files, droppedFiles, description, fileTypeName);
			action(fileUpload);
			if (isMarketValue) dispatch(setClaimRepairsEstimateFiles(fileUpload[0]));
		},

		onDropRejected: rejectedReason =>
			rejectedReason[0].errors.forEach(err =>
				toast.error(
					err.message.includes("larger")
						? "This document has exceeded the maximum size of 20MB and will not be submitted, please try another"
						: err.message.includes("type")
							? "This file type cannot be uploaded"
							: err.message,
					{ autoClose: 10000 }
				)
			),
		noClick: true,
		maxSize: MAX_SIZE,
		maxFiles: maxFiles,
		disabled,
		accept: "image/png, image/jpeg, image/heic, image/heif, application/pdf",
	});

	// const previewFileType = file => {
	// 	dispatch(setCurrentBlob(file.blob));
	// 	dispatch(setCurrentBlobModal(true));
	// };
	const previewFileType = file => {
		setBlobUrl(file.blob);
		setShowDocument(true);
	};
	const onDrop = async (files, acceptedFiles, description, name) => {
		let temp = [...files];
		for (let i = 0; i < acceptedFiles.length; i++) {
			let file = acceptedFiles[i];
			const fileExt = file.name.split(".").pop().toLowerCase();
			let optimizedFile;
			if (fileExt === "png" || fileExt === "gif" || fileExt === "jpg" || fileExt === "jpeg") {
				dispatch(setLoadingMessage("Compressing your image files..."));
				dispatch(setLoading(true));
				let temp = await toBase64(file);
				optimizedFile = await ClaimsNetworkLayer.compressFile(file, temp);
			}

			if (fileExt === "pdf") {
				dispatch(setLoadingMessage("Compressing your pdf files..."));
				dispatch(setLoading(true));
				let temp = await toBase64(file);
				optimizedFile = await ClaimsNetworkLayer.compressFile(file, temp);
				// optimizedFile = optimizedFile.replace(new RegExp("^data:.*base64,", "i"), "");
			}

			const blob = optimizedFile ? optimizedFile : await toBase64(file);
			const fileName = name ? name + "." + file.name.split(".").pop() : file.name;

			const size = file.size;
			const newObject = { name: fileName, blob: blob, description, size };

			const index = temp.findIndex(f => f.name === fileName);
			if (index > -1) {
				temp[index] = newObject;
			} else {
				temp = [...temp, newObject];
			}
		}
		dispatch(setLoading(false));
		return temp;
	};

	function limitText(text, charLimit) {
		let textLength = text.length;
		if (textLength > charLimit) {
			return text.substring(0, charLimit) + "...";
		} else {
			return text;
		}
	}

	return isUploadCenter ? (

		<DocumentCard
			title={sectionTitle}
			description={sectionTitle.toLowerCase() === "scheme proof" ? "e.g. your staff ID or job letter—so we can confirm your scheme affiliation." : "Action required to proceed with your policy update"}
			open={open}
			setUploadDropdown={setUploadDropdown}
			blobUrl={blobUrl}
			files={files}
			onDrop={onDrop}
			getInputProps={getInputProps}
			remove={remove}
			disabled={disabled}
			//subtitle={"Required for vehicle certification"}
			onUploadComplete={(files) => handleUploadComplete(files, f.name)}
			isRequired={isRequired}
		/>
	) : (isMarketValue && !isMarketValueUpdate) ? (
		<div className="market-val-upload-container">
			{/* {files.length > 0 && <img className="success-icon" src={successIcon} alt="upload folder" />} */}
			<div
				className="market-val-upload-section"
			>
				{/* <div className="document-to-upload">
					<img src={uploadFolder} alt="upload folder" />
					<h6>{description === "" ? <span style={{ color: "red" }}>Select document type</span> : description}</h6>
				</div> */}
				<div className="-upload-container">
					<input {...getInputProps()} />
					<div className={`-doc-upload-btn ${disabled ? "disabled" : ""}`} onClick={open}>
						<img
							src={uploadFileIcon}
							onClick={() => {
								open();
								setUploadDropdown(false);
							}}
							alt="upload"
						/>
						<span>Click to Upload or Drop files here</span>
					</div>
					<div className="-upload-info">
						<small>Maximum upload file size is: <b>20MB. JPG,PNG,PDF</b></small>
					</div>
				</div>
			</div>
			{files.length > 0 && (
				<div className="-uploaded-docs-section">
					<div className={`doc-display-section`}>
						{files?.map((file, i) => (
							<div key={`wind-file-item-${file.name}${i}`} className="uploaded-docs">
								<div className="uploaded-doc-info">
									<p>({i + 1}){file.name}</p>
									{/* <>{file.name.split(".").pop().toLowerCase()}</> */}
								</div>
								<div className="doc-preview">
									<div className="prev-controller-divider"></div>
									<img
										className="delete-btn"
										src={viewIcon}
										alt="view icon"
										onClick={
											ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
												? () => previewFileType(file)
												: null
										}
									/>
									
									<img className="delete-btn" src={trashIcon2} alt="delete icon" onClick={() => remove(file, i)} />
								</div>
							</div>
						))}
					</div>
				</div>
			)}
			<DocumentViewer
				showDocument={showDocument}
				fileData={blobUrl}
				onClose={() => setShowDocument(false)}
			/>
		</div>
	) : isWindscreenDamage ? (
		<div style={{ display:"grid", gap: "5px" }}>
			<div className="custom-file-upload-windscreen">  {/* new class for styling */}
				<div
					{...getRootProps({
						className: `upload-dropzone ${disabled ? "disabled" : ""} ${files.length === 0 && isWindscreenDamage ? "required" : ""}`,
					})}
				>
					<input {...getInputProps()} />

					<div className="upload-content" onClick={open}>
						{/* Upload icon - using simple SVG (or replace with your asset) */}
						<div className="upload-icon-container">
							{ uploadTypeIcon === undefined ?
							<svg 
								className="upload-icon"
								width="48"
								height="48"
								fill="#0ea5e9"
								xmlns="http://www.w3.org/2000/svg" 
								viewBox="0 0 640 640">
								<path d="M176 544C96.5 544 32 479.5 32 400C32 336.6 73 282.8 129.9 263.5C128.6 255.8 128 248 128 240C128 160.5 192.5 96 272 96C327.4 96 375.5 127.3 399.6 173.1C413.8 164.8 430.4 160 448 160C501 160 544 203 544 256C544 271.7 540.2 286.6 533.5 299.7C577.5 320 608 364.4 608 416C608 486.7 550.7 544 480 544L176 544zM337 255C327.6 245.6 312.4 245.6 303.1 255L231.1 327C221.7 336.4 221.7 351.6 231.1 360.9C240.5 370.2 255.7 370.3 265 360.9L296 329.9L296 432C296 445.3 306.7 456 320 456C333.3 456 344 445.3 344 432L344 329.9L375 360.9C384.4 370.3 399.6 370.3 408.9 360.9C418.2 351.5 418.3 336.3 408.9 327L336.9 255z"/>
							</svg> : uploadTypeIcon}
						</div>
	
						
						<div className="desktop-message">
							<h3 className="upload-heading">{title}</h3>
							{/* <p className="upload-instruction">
								Click to browse or drag and drop your images here
							</p> */}
							{!smallUpload ? <>
								<div className="upload-supported">
									{instruction ? 
										<p>{instruction}</p> :
										<p>Drag and drop your file here, or click to browse.</p>
									}  
									{/* <span>We accept JPG, PNG, or PDF formats.</span>
									<br/><small>Maximum upload file size is: 20MB</small> */}
								</div>
									
								<div 
									className="uploadbtn-cont"
								>
									Choose File
								</div>
								{/* <div className="more-info">
									<svg xmlns="http://www.w3.org/2000/svg" fill="#0ea5e9" viewBox="0 0 640 640"><path d="M320 64C324.6 64 329.2 65 333.4 66.9L521.8 146.8C543.8 156.1 560.2 177.8 560.1 204C559.6 303.2 518.8 484.7 346.5 567.2C329.8 575.2 310.4 575.2 293.7 567.2C121.3 484.7 80.6 303.2 80.1 204C80 177.8 96.4 156.1 118.4 146.8L306.7 66.9C310.9 65 315.4 64 320 64zM320 130.8L320 508.9C458 442.1 495.1 294.1 496 205.5L320 130.9L320 130.9z"/></svg>
									Secure Upload
								</div> */}
							</> : <>
								<div className="upload-supported-mini">
									{instruction ? 
										<p>{instruction}</p> :
										<p>Drag and drop your file here, or click to browse.</p>
									} 
									<div 
										 className="uploadbtn-cont"
									>
										Choose File
									</div>
									{/* <span>JPG, PNG, PDF • Max 20MB</span>  */}
								</div>
							</>}
						</div>

						<div className="mobile-message">
							<h3 className="upload-heading">{mobileTitle}</h3>
							{/* <p className="upload-instruction">
								Click to browse or drag and drop your images here
							</p> */}
							<p className="upload-supported"> 
								<span>JPG, PNG, PDF supported</span> 
							</p>

							<div 
								className="uploadbtn-cont"
							>
								Choose File
							</div>
							{/* <div className="more-info">
								<svg xmlns="http://www.w3.org/2000/svg" fill="#0ea5e9" viewBox="0 0 640 640"><path d="M320 64C324.6 64 329.2 65 333.4 66.9L521.8 146.8C543.8 156.1 560.2 177.8 560.1 204C559.6 303.2 518.8 484.7 346.5 567.2C329.8 575.2 310.4 575.2 293.7 567.2C121.3 484.7 80.6 303.2 80.1 204C80 177.8 96.4 156.1 118.4 146.8L306.7 66.9C310.9 65 315.4 64 320 64zM320 130.8L320 508.9C458 442.1 495.1 294.1 496 205.5L320 130.9L320 130.9z"/></svg>
								Secure Upload
							</div> */}
						</div>

						{/* <button
							type="button"
							className="browse-button"
							
							disabled={disabled}
						>
							Browse Files
						</button> */}
					</div>
				</div>
				
				{/* Uploaded files preview */}
				{/* {files.length > 0 && (
					<div className="uploaded-files">
						<p className="upload-count">
							{files.length} photo{files.length !== 1 ? "s" : ""} uploaded
						</p>

						<div className="file-list">
							{files.map((file, i) => (
								<div key={i} className="file-item">
									<div
										className="file-preview"
										onClick={() =>
											ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
												? previewFileType(file)
												: null
										}
									>
										
										{file.name.match(/\.(jpe?g|png|heic)$/i) ? (
											<img
												src={file.blob}
												alt={file.name}
												className="thumbnail"
											/>
										) : (
											<div className="file-icon">📄</div>
										)}
										<p className="file-name">{truncate(file.name, 25)}</p>
									</div>

									<div className="file-actions">
										<FaEye
											className="action-icon view"
											onClick={() => previewFileType(file)}
										/>
										<img
											src={trashIcon2 || "/assets/img/document-upload-icons/trash_icon2.svg"}
											className="action-icon delete"
											alt="Remove"
											onClick={() => remove(file, i)}
										/>
									</div>
								</div>
							))}
						</div>
					</div>
				)} */} 
			</div>
			<div style={{height: "50px"}}>
				<p className="footer-container">
					<svg style={{ width: "20px", height: "auto", marginRight: "5px", fill: "#0ea5e9" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
						<path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z" />
					</svg>  
					{footerMessage.length > 0 ? footerMessage : "Accepted formats: JPG, PNG, PDF (Max 20MB)"}
				</p> 
			</div>
			{errorHandling?.errorStatus ? <p style={{
				color: "red",
				fontSize: "14px"
			}}>
				{errorHandling?.errorMessage}
			</p> : null}
			{!hideFileList && files.length > 0 && (
				<div className="uploaded-files-list">
					{files.map((file, i) => (
						<div className="uploaded-file">
							<div 
								className="file-preview-container" 
								onClick={
									ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
									? () => previewFileType(file)
									: null
								}
							>
								<div className="file-image-preview">
									{/* <img 
										src={file.blob}
										alt={file.name}
										className="file-image"
									/> */}
									{/* {file.name.match(/\.(jpe?g|png|heic)$/i) ? (
										<img
											src={file.blob}
											alt={file.name}
											className="file-image"
											onClick={() => previewFileType(file)}
										/>
									) : (
										
									)} */}
									<div className="file-icon">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM224 176C250.5 176 272 197.5 272 224C272 250.5 250.5 272 224 272C197.5 272 176 250.5 176 224C176 197.5 197.5 176 224 176zM368 288C376.4 288 384.1 292.4 388.5 299.5L476.5 443.5C481 450.9 481.2 460.2 477 467.8C472.8 475.4 464.7 480 456 480L184 480C175.1 480 166.8 475 162.7 467.1C158.6 459.2 159.2 449.6 164.3 442.3L220.3 362.3C224.8 355.9 232.1 352.1 240 352.1C247.9 352.1 255.2 355.9 259.7 362.3L286.1 400.1L347.5 299.6C351.9 292.5 359.6 288.1 368 288.1z"/></svg>
									</div>
								</div>
								<div className="file-preview">
									<div className="file-name">{truncate(file.name, 25)}</div>
									<div className="uploaded-file-info">
										<span className="file-size"></span>
										<span className="file-status">Uploaded</span>
									</div>
								</div> 
							</div>
							<div className="control-container">   
								<div 
									className="delete-container" 
									onClick={() => remove(file, i)}
								>
									<svg className="delete-img" alt="Remove" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M232.7 69.9C237.1 56.8 249.3 48 263.1 48L377 48C390.8 48 403 56.8 407.4 69.9L416 96L512 96C529.7 96 544 110.3 544 128C544 145.7 529.7 160 512 160L128 160C110.3 160 96 145.7 96 128C96 110.3 110.3 96 128 96L224 96L232.7 69.9zM128 208L512 208L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 208zM216 272C202.7 272 192 282.7 192 296L192 488C192 501.3 202.7 512 216 512C229.3 512 240 501.3 240 488L240 296C240 282.7 229.3 272 216 272zM320 272C306.7 272 296 282.7 296 296L296 488C296 501.3 306.7 512 320 512C333.3 512 344 501.3 344 488L344 296C344 282.7 333.3 272 320 272zM424 272C410.7 272 400 282.7 400 296L400 488C400 501.3 410.7 512 424 512C437.3 512 448 501.3 448 488L448 296C448 282.7 437.3 272 424 272z"/></svg>
								</div>
								{/* <img
									src={trashIcon2 || "/assets/img/document-upload-icons/trash_icon2.svg"}
									className="delete-img"
									alt="Remove"
									onClick={() => remove(file, i)}
								/>  */}
							</div>
						</div>
					))}
				</div>
			)}
			<DocumentViewer
				showDocument={showDocument}
				fileData={blobUrl}
				onClose={() => setShowDocument(false)}
			/>
		</div>
	) : (
		<div
			className={`${
					isCatClaimForm 
					? "ccf-file-upload"
					: isSCDFlow
					? "custom-file-upload-scd"
					: isMarketValue
					? "custom-file-upload-mv"
					: isPolicyEditor
						? "custom-file-upload-pe"
						: isPolicyEditorContact
							? "custom-file-upload-pe contact"
							: isUploadCenter || isMarketValue || isMarketValueUpdate
								? ""
								: "custom-file-upload"
				}`}
			style={{
				backgroundColor: isMarketValueUpdate ? "" : (isSCDFlow && files.length > 0 ? "#fff" : "#fff"),
				border: isMarketValueUpdate ? "#F4F2F2" : "none",
			}}
		> 
			{isCatClaimForm ? (
				<>
					<div
						{...getRootProps({
							className: `upload-area-scd ${disabled ? "upload-area-scd-disabled" : ""}`,
						})}
					>
						<input id="doc-upload-uid" {...getInputProps()} />
						<div className="cnd-browse-files-scd" onClick={open}>
							<img className={"scd-upload"} src={uploadIcon} onClick={open} alt="upload" />
							<span className={disabled ? "upload-placeholder-disabled" : "upload-placeholder"}>{placeHolder}</span>
							{/* {files.length === 0 && ( */}
								<div style={{ textAlign: "center", color: "#959494" }}>
									<small>Maximum upload file size is: 20MB</small>
									<br />
									<small>JPG,PNG,PDF</small>
								</div>
							{/* )} */}
						</div>
						{/* <BiUpload color={${disabled ? "" : ""}} onClick={open} className="btn-icon" title="Upload" /> */}
					</div>
				</>
			) : isSCDFlow ? (
				<>
					<div
						{...getRootProps({
							className: `upload-area-scd ${disabled ? "upload-area-scd-disabled" : ""}`,
						})}
					>
						<input {...getInputProps()} />
						<div className="cnd-browse-files-scd" onClick={open}>
							<img className={"scd-upload"} src={upload_scd_active} onClick={open} alt="upload" />
							<span className={disabled ? "upload-placeholder-disabled" : "upload-placeholder"}>{placeHolder}</span>
						</div>
						{/* <BiUpload color={${disabled ? "" : ""}} onClick={open} className="btn-icon" title="Upload" /> */}
					</div>
					{files.length === 0 && (
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<small>Maximum upload file size is: 20MB</small>
							<br />
							<small>JPG,PNG,PDF</small>
						</div>
					)}
				</>
			) : false ? (
				<MarketValue files={files} getInputProps={getInputProps} open={open} remove={remove} disabled={disabled} />
			) : isPolicyEditor || isPolicyEditorContact ? (
				<>
					<div
						{...getRootProps({
							className: `upload-area-pe ${disabled ? "upload-area-pe-disabled" : ""}`,
						})}
					>
						<input {...getInputProps()} />
						<div className="cnd-browse-files-pe" onClick={open}>
							<img
								className={"pe-upload"}
								src={isPolicyEditorContact ? upload_scd_active : upload_pe}
								onClick={open}
								alt="upload"
							/>
							<span className={disabled ? "upload-placeholder-disabled" : "upload-placeholder"}>{placeHolder}</span>
						</div>
						{/* <BiUpload color={${disabled ? "" : ""}} onClick={open} className="btn-icon" title="Upload" /> */}
					</div>
				</>
			) : (
				(!isUploadCenter || !isMarketValue) &&
				!isMarketValueUpdate && (
					<div
						{...getRootProps({
							className: `cnd-browse-files upload-area ${disabled ? "disabled" : ""}`,
						})}
					>
						<input {...getInputProps()} />
						<span className="upload-placeholder">{placeHolder}</span>
						<span className={`upload-button ${disabled ? "disabled" : ""}`} onClick={open}>
							<BiUpload className="btn-icon" title="Upload" />
							Upload
						</span>
					</div>
				)
			)}
			{!isMarketValue && !isUploadCenter && !isMarketValueUpdate && (
				<>
					{name === "Other"
						? Object.keys(files).length === 0 && <div className="blue-box"> </div>
						: files?.length === 0 && <div className="blue-box"> </div>}
				</>
			)}

			{isSCDFlow && files.length !== 0 && !isMarketValueUpdate && !isMarketValue && !isUploadCenter && (
				<div className="input-verbiage">
					<small className="confirm-verbiage"> {files.length} Document(s)</small>
					<div style={{ textAlign: "right" }}>
						<small>Maximum upload file size is: 20MB</small>
						<br />
						<small>JPG,PNG,PDF</small>
					</div>
				</div>
			)}

			{!isMarketValue && !isUploadCenter && !isMarketValueUpdate && (
				<>
					{!isSCDFlow && !isUploadCenter && (
						<>
							{!isPolicyEditor && !isPolicyEditorContact && !isCatClaimForm && (
								<div className="input-verbiage">
									<small className="confirm-verbiage"> {files.length} Document(s)</small>
									<div style={{ textAlign: "right" }}>
										<small>Maximum upload file size is: 20MB</small>
										<br />
										<small>JPG,PNG,PDF</small>
									</div>
								</div>
							)}
						</>
					)}
				</>
			)}

			{!isMarketValue && !isUploadCenter && !isMarketValueUpdate && !isSCDFlow && (
				<div style={{ border: "none" }} className="file">
					{files?.map((file, i) => (
						<>
							<div
								key={`wind-file-item-${file.name}${i}`}
								className={"files " + (files.length > 1 && i > 0 ? "files-border" : "")}
							>
								<div
									className="uploaded-container"
									onClick={
										ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
											? () => previewFileType(file)
											: null
									}
								>
									<p
										style={{ margin: 0, alignSelf: "center", color: "#002868" }}
										className={`${ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
											? "filename-clickable"
											: "filename"
											} text-truncate`}
									>
										{" "}
										({i + 1}) {file.name}
									</p>
								</div>
								<div className="btn-container">
									<FaEye
										onClick={
											ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
												? () => previewFileType(file)
												: null
										}
										className="preview-icon"
									/>
									<div style={{ borderLeft: "2px solid #00bfff", height: "35px" }}></div>
									<img src={delete_btn} style={{ cursor: "pointer" }} alt="delete" onClick={() => remove(file, i)} />
								</div>
							</div>
						</>
					))}
				</div>
			)}

			{isSCDFlow &&
			
				<div className="uploaded-files-list">
					{files.map((file, i) => (
						<div className="uploaded-file">
							<div 
								className="file-preview-container" 
								onClick={
									ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
									? () => previewFileType(file)
									: null
								}
							>
								<div className="file-image-preview">
									{/* <img 
										src={file.blob}
										alt={file.name}
										className="file-image"
									/> */}
									{/* {file.name.match(/\.(jpe?g|png|heic)$/i) ? (
										<img
											src={file.blob}
											alt={file.name}
											className="file-image"
											onClick={() => previewFileType(file)}
										/>
									) : (
										
									)} */}
									<div className="file-icon">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM224 176C250.5 176 272 197.5 272 224C272 250.5 250.5 272 224 272C197.5 272 176 250.5 176 224C176 197.5 197.5 176 224 176zM368 288C376.4 288 384.1 292.4 388.5 299.5L476.5 443.5C481 450.9 481.2 460.2 477 467.8C472.8 475.4 464.7 480 456 480L184 480C175.1 480 166.8 475 162.7 467.1C158.6 459.2 159.2 449.6 164.3 442.3L220.3 362.3C224.8 355.9 232.1 352.1 240 352.1C247.9 352.1 255.2 355.9 259.7 362.3L286.1 400.1L347.5 299.6C351.9 292.5 359.6 288.1 368 288.1z"/></svg>
									</div>
								</div>
								<div className="file-preview">
									<div className="file-name">{truncate(file.name, 25)}</div>
									<div className="uploaded-file-info">
										<span className="file-size"></span>
										<span className="file-status">Uploaded</span>
									</div>
								</div> 
							</div>
							<div className="control-container">   
								<div 
									className="delete-container" 
									onClick={() => remove(file, i)}
								>
									<svg className="delete-img" alt="Remove" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M232.7 69.9C237.1 56.8 249.3 48 263.1 48L377 48C390.8 48 403 56.8 407.4 69.9L416 96L512 96C529.7 96 544 110.3 544 128C544 145.7 529.7 160 512 160L128 160C110.3 160 96 145.7 96 128C96 110.3 110.3 96 128 96L224 96L232.7 69.9zM128 208L512 208L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 208zM216 272C202.7 272 192 282.7 192 296L192 488C192 501.3 202.7 512 216 512C229.3 512 240 501.3 240 488L240 296C240 282.7 229.3 272 216 272zM320 272C306.7 272 296 282.7 296 296L296 488C296 501.3 306.7 512 320 512C333.3 512 344 501.3 344 488L344 296C344 282.7 333.3 272 320 272zM424 272C410.7 272 400 282.7 400 296L400 488C400 501.3 410.7 512 424 512C437.3 512 448 501.3 448 488L448 296C448 282.7 437.3 272 424 272z"/></svg>
								</div>
								{/* <img
									src={trashIcon2 || "/assets/img/document-upload-icons/trash_icon2.svg"}
									className="delete-img"
									alt="Remove"
									onClick={() => remove(file, i)}
								/>  */}
							</div>
						</div>
					))}
				</div>

			}

			{isUploadCenter && !isMarketValueUpdate && (
				<div className="document-center-upload-container">
					<div style={{ display: "block" }}>
						<div className="upload-button-block">
							<div className="d-flex align-self-end">
								{files.length ? (
									<IconContext.Provider
										value={{
											color: "#c4d600",
											size: "3em",
											style: {
												verticalAlign: "middle",
												marginLeft: "45%",
												marginBottom: 10,
												transform: "translateX(-40%)",
											},
										}}
									>
										<div>
											<FaCheck contentStyleType={"fad"} />
										</div>
									</IconContext.Provider>
								) : (
									<IconContext.Provider
										value={{
											color: "#ffa000",
											size: "3em",
											style: {
												verticalAlign: "middle",
												marginLeft: "45%",
												marginBottom: 10,
												transform: "translateX(-40%)",
											},
										}}
									>
										<div>
											<FaExclamationTriangle contentStyleType={"fad"} />
										</div>
									</IconContext.Provider>
								)}
								<p className="title align-self-center">{sectionTitle}</p>
							</div>

							<div
								{...getRootProps({
									className: `d-flex align-self-start cnd-browse-files upload-area ${disabled ? "disabled" : ""}`,
								})}
							>
								<input {...getInputProps()} />
								<span className="upload-placeholder">{placeHolder}</span>
								<span className={`upload-button ${disabled ? "disabled" : ""}`} onClick={open}>
									<BiUpload className="btn-icon" title="Upload" />
									Upload
								</span>
							</div>
						</div>
					</div>

					<div style={{ border: "none" }} className="file">
						{files?.map((file, i) => (
							<>
								<div
									key={`wind-file-item-${file.name}${i}`}
									className={"files " + (files.length > 1 && i > 0 ? "files-border" : "")}
								>
									<div
										className="uploaded-container"
										onClick={
											ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
												? () => previewFileType(file)
												: null
										}
									>
										<p
											style={{ margin: 0, alignSelf: "center", color: "#002868" }}
											className={`${ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
												? "filename-clickable"
												: "filename"
												} text-truncate`}
										>
											{" "}
											({i + 1}) {file.name}
										</p>
									</div>
									<div className="btn-container">
										<FaEye
											onClick={
												ACCEPTED_PREVIEW_FILE_TYPES.includes(file.name.split(".").pop().toLowerCase())
													? () => previewFileType(file)
													: null
											}
											className="preview-icon"
										/>
										<div style={{ borderLeft: "2px solid #00bfff", height: "35px" }}></div>
										<img src={delete_btn} style={{ cursor: "pointer" }} alt="delete" onClick={() => remove(file, i)} />
									</div>
								</div>
							</>
						))}
					</div>

					<div className="input-verbiage">
						<div style={{ textAlign: "right" }}>
							<small>Maximum upload file size is: 20MB</small>
							<br />
							<small>JPG,PNG,PDF</small>
						</div>
					</div>
				</div>
			)}

			{isMarketValueUpdate && (
				<div
					className={` d-sm-flex justify-content-between`}
					style={{
						minHeight: "50px",
						height: "auto",
						borderRadius: changeBorder ? 10 : "25px",
						background: files?.length === 0 ? "#bbbbbb" : changeBorder ? "#475569" : "#84BD00",
						padding: files?.length === 0 ? "0 20px" : "10px 25px",
						position: "relative",
						display: "flex",
					}}
					onClick={() => { files?.length > 0 && action() }}
				>
					<div
						className="m-0"
						style={{
							cursor: "pointer",
							alignItems: "center",
							alignContent: files?.length === 0 ? "space-evenly" : "unset"
						}}
					// onClick={open}
					>
						{/* <input {...getInputProps()} /> */}
						<img src={fileUploadImg} width={20} height={25} alt="file upload" />
					</div>

					<div
						className="px-2"
						style={{ width: "100%", textAlignLast: "left", height: "fit-content", margin: "auto", textAlignLast: "center" }}
					>
						<div
						// onClick={open}
						>
							{/* <input {...getInputProps()} /> */}
							<span style={{ color: "#fff", fontWeight: "bold", marginBottom: 0, fontSize: "14px", cursor: "pointer" }}>Files <span className="uploaded-word">Uploaded</span> <span style={{ display: files?.length < 1 && "none"  ,backgroundColor: "gray", padding: "5px 10px", margin: "0 2.5px", borderRadius: 5}}>{files?.length > 0 ? `${files?.length}` : ""}</span> </span>
						</div>
					</div>
				</div>
			)}
			
			<DocumentViewer
				showDocument={showDocument}
				fileData={blobUrl}
				onClose={() => setShowDocument(false)}
			/>
		</div>
	);
}


